import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataCondition } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_CONDITION = defineMasterdataEntity<MasterdataCondition>({
  name: 'condition',
  responseKey: 'conditions',
  displayWith: (c) => keyName(c.key, c.name),
  secondaryWith: (c) => c.description,
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-plus-minus',
  title: 'Zu-/Abschlagsuche',
  label: 'Zu-/Abschlag',
  placeholder: 'Zu-/Abschlag suchen...',
  columns: [
    {
      label: 'Zu-/Abschlag',
      type: 'entity',
      icon: 'fa-regular fa-plus-minus',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) => e.description,
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'Beschreibung', type: 'text', value: (e) => e.description },
    { label: 'Aktiv', type: 'text', value: (e) => (e.active ? 'Ja' : 'Nein') },
    { label: 'Laufende Nummer', type: 'text', value: (e) => e.sequentialNumber },
  ],
});
